import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import SessionDialog from './SessionDialog'

const Stars = styled.div`
  display: flex;
  gap: 4px;
  font-size: 28px;
  margin-bottom: 16px;
`

const Star = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 32px;
  line-height: 1;
  color: ${(p) => (p.$on ? '#E0A526' : 'rgba(0,0,0,0.18)')};
  transition: transform 120ms ease-out;
  &:hover { transform: scale(1.1); }
`

const TextArea = styled.textarea`
  width: 100%;
  min-height: 84px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  &:focus {
    outline: 2px solid ${(p) => p.theme?.color?.primary || '#1F3A5F'};
    outline-offset: 1px;
  }
`

export default function FeedbackDialog({ open, session, existing, onClose, onSubmit }) {
  const [rating, setRating] = useState(0)
  const [text, setText] = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    setRating(existing?.rating || 0)
    setText(existing?.text || '')
  }, [existing, open])

  async function handleSubmit() {
    setBusy(true)
    try {
      await onSubmit({ rating, text: text.trim() || null })
      onClose()
    } finally {
      setBusy(false)
    }
  }

  if (!session) return null

  return (
    <SessionDialog
      open={open}
      title={existing ? 'Update your feedback' : 'How was your session?'}
      subtitle={`${session.practitionerName} will see your rating in their summary.`}
      primaryLabel={existing ? 'Update' : 'Submit'}
      primaryDisabled={!rating}
      primaryLoading={busy}
      onPrimary={handleSubmit}
      onClose={onClose}
    >
      <Stars role="radiogroup" aria-label="Rating">
        {[1, 2, 3, 4, 5].map((n) => (
          <Star
            key={n}
            $on={n <= rating}
            aria-label={`${n} stars`}
            onClick={() => setRating(n)}
          >
            ★
          </Star>
        ))}
      </Stars>
      <TextArea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Optional: anything you'd like to add"
      />
    </SessionDialog>
  )
}
